module.exports = __webpack_public_path__ + "img/18.a01cd0e3.png";